import { injectable } from 'inversify';
import dayjs, { Dayjs } from 'dayjs';

const namespace = 'idleTime';
const idleAfterSeconds: number = 30;

@injectable()
export class SectionDuration {
  private interval: number|null = null;
  private durationSecondsInternal: number = 0;
  private lastActivityStartedAt: Dayjs|null = null;
  private idle: boolean = false;

  public get durationSeconds(): number {
    return this.durationSecondsInternal;
  }

  public start(): void {
    this.listenForEvents();

    if (this.interval !== null) {
      clearInterval(this.interval);
      this.durationSecondsInternal = 0;
    }

    this.interval = setInterval(() => this.handle(), 1000);
  }

  private listenForEvents(): void {
    const events: string = `mousemove.${namespace} keyup.${namespace}`;
    $(document).off(events);
    $(document).on(events, () => this.resetLastActivityStartedAt());

    const $scrollElement: any = $('.scrollable-box');
    const scrollEvent = `scroll.${namespace}`;
    $scrollElement.off(scrollEvent);
    $scrollElement.on(scrollEvent, () => this.resetLastActivityStartedAt());
  }

  private resetLastActivityStartedAt(): void {
    this.lastActivityStartedAt = dayjs();
  }

  private handle(): void {
    if (!this.idle) {
      this.durationSecondsInternal++;
    }

    if (this.lastActivityStartedAt !== null) {
      const now: Dayjs = dayjs();
      const inactiveFor: number = dayjs.duration(now.diff(this.lastActivityStartedAt)).asSeconds();
      this.idle = inactiveFor > idleAfterSeconds;
    }
  }
}

export const SectionDurationSymbol = Symbol.for('SectionDuration');
